import { array, boolean, number, object, string } from 'yup'
import { AaaAssistConfirmResponse, ScenarioResponse } from './aaa-assist.types'

// club-svc takes the issue type from the club's options and can omit it or send a catalogue
// value outside `IssueType`, like `issue.model.ts`.
const issueTypeSchema = string().optional()

// club-svc only asks the model for a 0..1 confidence; nothing checks it server-side.
const confidenceSchema = number().min(0).max(1).required()

const ScenarioCandidateSchema = object().shape({
  optionCode: string().required(),
  label: string().required(),
  issueType: issueTypeSchema,
})

// One schema per `status`: the backend does not guarantee the model's output fits the contract,
// so a half-filled response must fail here instead of reaching the store.
const ScenarioClarifyResponseSchema = object().shape({
  status: string().oneOf(['clarify']).required(),
  question: string().required(),
  candidates: array().of(ScenarioCandidateSchema).min(1).required(),
  confidence: confidenceSchema,
  confirmed: boolean().required(),
})

const ScenarioClassifiedResponseSchema = object().shape({
  status: string().oneOf(['classified']).required(),
  optionCode: string().required(),
  pacesetterCode: string().required(),
  issueType: issueTypeSchema,
  requiresTowing: boolean().required(),
  // Missing when club-svc forces a commit after the last clarifying question.
  confirmationPrompt: string().optional(),
  confidence: confidenceSchema,
  confirmed: boolean().required(),
})

// Throws a yup ValidationError when the response does not fit the schema of its `status`.
export const validateScenarioResponse = (response: ScenarioResponse): ScenarioResponse => {
  const schema =
    response?.status === 'clarify' ? ScenarioClarifyResponseSchema : ScenarioClassifiedResponseSchema
  schema.validateSync(response)
  return response
}

export const AaaAssistConfirmResponseSchema = object<AaaAssistConfirmResponse>().shape({
  status: string().oneOf(['classified']).required(),
  optionCode: string().required(),
  pacesetterCode: string().required(),
  issueType: issueTypeSchema,
  requiresTowing: boolean().required(),
  confirmed: boolean().oneOf([true]).required(),
})
